import { useEffect, useState } from 'react';
import { useStore } from './useStore';
import { logger } from '../services/logger';
import { useSocketSubscribeUnsubscribe, useSocketTopicEvents } from '../microservices/pusher';
import { stores } from '../stores';
import { getRafBannerMessageProperties } from '../services/refer-a-friend';
import moment from 'moment';
import { RafBannerProperties } from '../microservices/refer-a-friend/types';

export const useReferAFriend = (userId?: string) => {
    const [isAuthenticated] = useStore(stores.isAuthenticated);
    const [rafBannerMessage, setRafBannerMessage] = useState<RafBannerProperties | null>(null);
    const [bannerMessageLastRequest, setBannerMessageLastRequest] = useState<string | null>(null);

    useEffect(() => {
        if (userId) {
            const is15minutesAfter =
                !bannerMessageLastRequest || moment().isAfter(moment(bannerMessageLastRequest).add(15, 'minutes'));
            if (is15minutesAfter) {
                loadRafBanner();
            }
        } else {
            setRafBannerMessage(null);
        }
    }, [userId]);

    async function loadRafBanner() {
        setBannerMessageLastRequest(new Date().toISOString());
        try {
            const rafBannerMessageProperties = await getRafBannerMessageProperties(userId);
            if (rafBannerMessageProperties) {
                setRafBannerMessage(rafBannerMessageProperties);
            }
        } catch (error) {
            logger.error('useReferAFriend', 'load', error);
        }
    }

    useSocketSubscribeUnsubscribe(`private`, {
        params: {
            service: `locks`,
            channel: 'balance-wagering-update',
        },
        guardFunction: () => isAuthenticated,
        watchParams: [isAuthenticated],
    });

    useSocketTopicEvents(
        `balance-wagering-update`,
        (updatedBalanceWagering) => {
            if (rafBannerMessage) {
                if (rafBannerMessage.wager_requirement && rafBannerMessage.lock_id === updatedBalanceWagering?.lockId) {
                    if (updatedBalanceWagering.balanceWagering <= 0) {
                        setRafBannerMessage(null);
                    } else {
                        setRafBannerMessage({
                            ...rafBannerMessage,
                            wagered_amount: rafBannerMessage.wager_requirement - updatedBalanceWagering.balanceWagering,
                        });
                    }
                }
            }
        },
        [rafBannerMessage],
    );
    return { rafBannerMessage };
};
